import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const listSectionHeader = tv({
  slots: {
    root: "flex items-center gap-2",
    text: "shrink-0 text-xs font-semibold leading-4 text-neutral-400",
    line: "h-px flex-1 bg-neutral-100",
  },
});

export interface ListSectionHeaderProps {
  children: ReactNode;
  className?: string;
}

/**
 * Small quiet section label with a hairline flex-1 divider running to the row's end.
 * Presentational: consumers nest it inside their own header element (ListBoxHeader,
 * MenuHeader) so each list keeps its RAC semantics and spacing.
 */
export function ListSectionHeader({ children, className }: ListSectionHeaderProps) {
  const styles = listSectionHeader();
  return (
    <div className={styles.root({ className })}>
      <span className={styles.text()}>{children}</span>
      <div aria-hidden className={styles.line()} />
    </div>
  );
}
